(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('saasEvents', ["path", "$q", "securityEventsDao", "securityEventTypes", "routeHelper", function (path, $q, securityEventsDao, securityEventTypes, routeHelper) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('summary-report/saas-events').template('saas-events'),
            scope: { saas: '=?' },
            link: function ($scope, element, attrs) {
                $scope.saas = $scope.saas || {};
                $scope.loading = true;
                var timeoutDeferred = $q.defer();
                $scope.eventsConf = {
                    resolutions: [
                        {
                            id: 'all',
                            label: 'Total',
                            highlight: true
                        },
                        {
                            id: 'week',
                            label: 'Week'
                        },
                        {
                            id: 'month',
                            label: 'Month'
                        }
                    ],
                    filterStates: [
                        'new',
                        'remediated'
                    ],
                    overwriteLabels: { 'suspicious': 'Suspicious Phishing' }
                };
                $scope.load = function () {
                    var queries = [];
                    var results = {};
                    timeoutDeferred.resolve();
                    timeoutDeferred = $q.defer();
                    _($scope.eventsConf.resolutions).each(function (resolution) {
                        var query;
                        if (resolution.id === 'all') {
                            query = securityEventsDao.list().params({ groupBy: 'type' }).params({ filterEnum_current_state: $scope.eventsConf.filterStates.join(',') });
                        } else {
                            query = securityEventsDao.list().params({
                                resolutionColumn: 'create_time',
                                resolutionStep: resolution.id,
                                resolutionFromNow: true,
                                resolutionMax: 1,
                                resolutionFields: 'type'
                            }).params({ filterEnum_current_state: $scope.eventsConf.filterStates.join(',') });
                        }
                        query = query.params({ filterEnum_saas: $scope.saas.name }).timeout(timeoutDeferred.promise).then(function (response) {
                            results[resolution.id] = _(response.data.rows).reduce(function (memo, row) {
                                memo = memo || {};
                                memo[row.type] = row;
                                return memo;
                            }, {});
                        });
                        queries.push(query);
                    });
                    return $q.all(queries).then(function () {
                        $scope.eventsRows = [];
                        _(securityEventTypes.data()).each(function (eventType) {
                            var row = _($scope.eventsConf.resolutions).map(function (resolution) {
                                return {
                                    value: results[resolution.id] && results[resolution.id][eventType.id] && results[resolution.id][eventType.id].count || 0,
                                    href: routeHelper.eventsHref(eventType.id, resolution.id, $scope.eventsConf.filterStates, $scope.saas.name),
                                    'class': { highlighted: resolution.highlight }
                                };
                            });
                            if (_(row).find('value')) {
                                $scope.eventsRows.push({
                                    label: $scope.eventsConf.overwriteLabels[eventType.id] || eventType.label,
                                    data: row
                                });
                            }
                        });
                        $scope.loading = false;
                    });
                };
                if (!_($scope.saas).isEmpty()) {
                    $scope.load();
                }
                $scope.$on('$locationChangeStart', function (event, next) {
                    timeoutDeferred.resolve();
                });
            }
        };
    }]);
}());